var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdentityDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#08EEFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1080_3282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2499 34H14.7501C13.233 34 12 32.767 12 31.2499V18.7501C12 17.233 13.233 16 14.7501 16H33.2499C34.767 16 36 17.233 36 18.7501V31.2499C36 32.767 34.767 34 33.2499 34ZM14.7501 17.5C14.061 17.5 13.5 18.061 13.5 18.7501V31.2499C13.5 31.939 14.061 32.5 14.7501 32.5H33.2499C33.939 32.5 34.5 31.939 34.5 31.2499V18.7501C34.5 18.061 33.939 17.5 33.2499 17.5H14.7501Z",
    fill: "#08EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 25.0001C18.1219 25.0001 17.0001 23.878 17.0001 22.5001C17.0001 21.1221 18.1219 20 19.5 20C20.8781 20 21.9999 21.1221 21.9999 22.5001C21.9999 23.878 20.8781 25.0001 19.5 25.0001ZM19.5 21.5C18.949 21.5 18.5001 21.949 18.5001 22.5001C18.5001 23.0511 18.949 23.5001 19.5 23.5001C20.051 23.5001 20.4999 23.0511 20.4999 22.5001C20.4999 21.949 20.051 21.5 19.5 21.5Z",
    fill: "#08EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 30.0001C22.836 30.0001 22.5 29.6641 22.5 29.2501V28.7501C22.5 28.061 21.939 27.5 21.2499 27.5H17.7501C17.061 27.5 16.5 28.061 16.5 28.7501V29.2501C16.5 29.6641 16.164 30.0001 15.75 30.0001C15.336 30.0001 15 29.6641 15 29.2501V28.7501C15 27.233 16.233 26 17.7501 26H21.2499C22.767 26 24 27.233 24 28.7501V29.2501C24 29.6641 23.664 30.0001 23.25 30.0001Z",
    fill: "#08EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.25 22H26.7501C26.3361 22 26.0001 21.664 26.0001 21.25C26.0001 20.836 26.3361 20.5 26.7501 20.5H32.25C32.664 20.5 33 20.836 33 21.25C33 21.664 32.664 22 32.25 22Z",
    fill: "#08EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.25 26H26.7501C26.3361 26 26.0001 25.664 26.0001 25.25C26.0001 24.836 26.3361 24.5 26.7501 24.5H32.25C32.664 24.5 33 24.836 33 25.25C33 25.664 32.664 26 32.25 26Z",
    fill: "#08EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.25 30H26.7501C26.3361 30 26.0001 29.664 26.0001 29.25C26.0001 28.836 26.3361 28.5 26.7501 28.5H32.25C32.664 28.5 33 28.836 33 29.25C33 29.664 32.664 30 32.25 30Z",
    fill: "#08EEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1080_3282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentityDocument);
export default __webpack_public_path__ + "static/media/identity-Document.17b0abcb87dcf4499d6bd2c13a7a9464.svg";
export { ForwardRef as ReactComponent };